import { ComplexBase } from '@syncfusion/ej2-react-base';
export class RangeBandSettingDirective extends ComplexBase {
}
RangeBandSettingDirective.moduleName = 'rangeBandSetting';
export class RangeBandSettingsDirective extends ComplexBase {
}
RangeBandSettingsDirective.propertyName = 'rangeBandSettings';
RangeBandSettingsDirective.moduleName = 'rangeBandSettings';
